'use strict';
var inputsList = document.querySelectorAll('form input');
inputsList.forEach(function(input) {
    var label = document.createElement('label');
    label.className = 'field-label';
    label.textContent = input.name;
    label.htmlFor = input.id;
    input.parentNode.insertBefore(label, input);
    var firstletter = input.name[0].toUpperCase();
    input.placeholder = "".concat(firstletter).concat(input.name.slice(1));
});

//# sourceMappingURL=js_task_fix_form_DOM.f7105e73.js.map
